// Keep the memo preview's existing extensions and safe defaults, using the
// installed parser. vue3-markdown-it embeds an old parser in its published bundle.
function defaultExport(plugin) {
  return plugin.default || plugin
}

const markdown = require("markdown-it")()
  .use(defaultExport(require("markdown-it-abbr")))
  .use(defaultExport(require("markdown-it-anchor")))
  .use(defaultExport(require("markdown-it-deflist")))
  .use(defaultExport(require("markdown-it-emoji")))
  .use(defaultExport(require("markdown-it-footnote")))
  .use(defaultExport(require("markdown-it-highlightjs")))
  .use(defaultExport(require("markdown-it-ins")))
  .use(defaultExport(require("markdown-it-mark")))
  .use(defaultExport(require("markdown-it-sub")))
  .use(defaultExport(require("markdown-it-sup")))
  .use(defaultExport(require("markdown-it-task-lists")))
  .use(defaultExport(require("markdown-it-toc-done-right")))

function renderMarkdownPreview(source) {
  return markdown.render(source)
}

module.exports = { renderMarkdownPreview }
